function stateCode(fixture) {
  return String(
    fixture?.state?.state ||
    fixture?.state?.short_name ||
    fixture?.state?.developer_name ||
    ""
  ).toUpperCase();
}

function score(fixture, description) {
  const result = {};
  for (const item of Array.isArray(fixture?.scores) ? fixture.scores : []) {
    if (String(item?.description || "").toUpperCase() !== description) continue;
    const side = String(item?.score?.participant || "").toLowerCase();
    const goals = Number(item?.score?.goals);
    if (["home", "away"].includes(side) && Number.isFinite(goals)) result[side] = goals;
  }
  return Number.isFinite(result.home) && Number.isFinite(result.away) ? result : null;
}

export function formatFixtureResult(fixture, separator = ":") {
  const state = stateCode(fixture);
  if (["NS", "TBA", "POSTP", "POSTPONED"].includes(state)) return "";
  const current = score(fixture, "CURRENT");
  if (!current) return "";
  const result = `${current.home}${separator}${current.away}`;
  if (["FT", "FT_PEN", "AET"].includes(state) && current.home === 0 && current.away === 0) {
    return result;
  }
  const halfTime = score(fixture, "1ST_HALF");
  const mayShowHalfTime = ["FT", "FT_PEN", "AET", "HT", "2H"].includes(state) ||
    state.includes("HALF_TIME") || state.includes("HALFTIME") ||
    state.includes("2ND_HALF") || state.includes("SECOND_HALF") ||
    state.includes("EXTRA_TIME") || state === "ET";
  return mayShowHalfTime && halfTime
    ? `${result} (${halfTime.home}${separator}${halfTime.away})`
    : result;
}
